import React, { useEffect } from 'react';

// Closes popovers (dropdown panels) on a click anywhere outside the given element.
export function useClickOutside(ref: React.RefObject<HTMLElement>, onOutside: () => void) {
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) onOutside();
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [ref, onOutside]);
}
